import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";

import mr from "./i18n/locales/mr/translation.json";
import en from "./i18n/locales/en/translation.json";
import hi from "./i18n/locales/hi/translation.json";
import kn from "./i18n/locales/kn/translation.json";

const savedLang = localStorage.getItem("app_lang") || "mr";

i18n
  // ✅ Remove detector for now (we will add later after stable)
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      mr: { translation: mr },
      en: { translation: en },
      hi: { translation: hi },
      kn: { translation: kn },
    },

    lng: savedLang, // ✅ FORCE start language from app_lang
    fallbackLng: "mr",
    supportedLngs: ["mr", "en", "hi", "kn"],

    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export default i18n;
